import Backend from "./Backend";
import {selectedCompanyStore} from "../store/SelectedCompany";
import {GetSalesInvoiceListDto} from "../model/invoice/sales/GetSalesInvoiceListDto";
import {Moment} from "moment";
import {CreateSalesInvoiceDto} from "../model/invoice/sales/CreateSalesInvoiceDto";
import {GetSalesInvoiceDetailsDto} from "../model/invoice/sales/GetSalesInvoiceDetailsDto";
import {SendInvoiceByEmail} from "../model/invoice/sales/SendInvoiceByEmail";
import {formatMonth} from "../utils/DataFormat";
import {AsyncTaskStatus} from "../model/AsyncTask";
import FetchSalesInvoicesForReviewResponse from "../model/invoice/sales/FetchSalesInvoicesForReviewResponse";
import {ResultOrErrorDto} from "../model/ResultOrErrorDto";
import {FileResponseDto} from "../model/FileResponseDto";

class SalesInvoiceApi {

    public fetchInvoices(from: Moment, to: Moment): Promise<GetSalesInvoiceListDto[]> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/sales?from=${Backend.date(from)}&to=${Backend.date(to)}`);
    }

    public checkInvoiceNumber(invoiceNumber: string): Promise<{ canUse: boolean }> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/sales/check/number`, {
            invoiceNumber
        });
    }

    public getNextInvoiceNumber(): Promise<{ nextNumber: string }> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/sales/number/next`);
    }

    public deleteInvoice(invoiceId: string): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.delete(`/api/v1/company/${companyId}/invoice/sales/${invoiceId}`);
    }

    public getInvoice(invoiceId: string): Promise<GetSalesInvoiceDetailsDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/sales/${invoiceId}`);
    }

    public downloadInvoice(invoiceId: string): Promise<FileResponseDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/sales/${invoiceId}/pdf`);
    }

    public sendInvoice(invoiceId: string, data: SendInvoiceByEmail): Promise<void> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/sales/${invoiceId}/email`, data);
    }

    public previewInvoice(data: CreateSalesInvoiceDto): Promise<FileResponseDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/sales/preview`, data);
    }

    public createInvoice(data: CreateSalesInvoiceDto): Promise<GetSalesInvoiceDetailsDto> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/sales`, data);
    }

    public startReviewGeneration(month: Moment): Promise<string> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.post(`/api/v1/company/${companyId}/invoice/sales/review`, {month: formatMonth(month)});
    }

    public fetchReviewStatus(taskId: string): Promise<AsyncTaskStatus> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/sales/review/${taskId}/status`);
    }

    public fetchReviewResult(taskId: string): Promise<ResultOrErrorDto<FetchSalesInvoicesForReviewResponse>> {
        const companyId = selectedCompanyStore.companyId;
        return Backend.get(`/api/v1/company/${companyId}/invoice/sales/review/${taskId}/result`);
    }
}

export const salesInvoiceApi = new SalesInvoiceApi();